import { render, staticRenderFns } from "./dossiers-create-view.vue?vue&type=template&id=7ca9e829&scoped=true"
import script from "./dossiers-create-view.vue?vue&type=script&lang=ts"
export * from "./dossiers-create-view.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca9e829",
  null
  
)

export default component.exports